/**
 * Detects the device type from the browser's user agent string.
 * Used to add a deviceType dimension to Katal metrics for tracking
 * mobile vs desktop usage of Seller University.
 */
export const getDeviceType = (): string => {
  try {
    const ua = navigator.userAgent;

    // Tablet detection — checked before mobile because some tablet UAs contain "Mobile"
    // (e.g., iPad UA includes "Mobile/15E148"). Covers three cases:
    // 1. Legacy tablet UA keywords (iPad, PlayBook, Silk/Fire tablets)
    // 2. Modern iPads (iPadOS 13+) which send a "Macintosh" UA but report
    //    maxTouchPoints > 1 (typically 5), unlike real Macs which report 0
    // 3. Android tablets (Samsung Galaxy Tab, Lenovo Tab, etc.) which contain
    //    "Android" but omit "Mobile" — Android phones always include "Mobile"
    if (
      /tablet|ipad|playbook|silk/i.test(ua)
      || (navigator.maxTouchPoints > 1 && /Macintosh/i.test(ua))
      || (/android/i.test(ua) && !/mobile/i.test(ua))
    ) return 'Tablet';

    // Mobile detection: matches common mobile device identifiers in the UA string
    if (/mobile|iphone|ipod|android.*mobile|windows phone/i.test(ua)) return 'Mobile';

    return 'Desktop';
  } catch {
    return 'Unknown';
  }
};
